import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Fragment } from "react";
import { textAlign } from "@mui/system";
import { Link, useNavigate } from "react-router-dom";
import mailImage from "../../../assets/images/mailIcon.png";
import LabelInputLeftIcon from "../../@common/Input/LabelInputLeftIcon";
import FormCheckboxes from "../../@common/Input/chexboxes";
import sucessImage from "../../../assets/images/thankimage.png";
import { useTranslation } from "react-i18next";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  maxWidth: "95%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 4,
};

const subjectList = ["The present subject is found"];

const SuccessfullModal = (props) => {
  const {
    text = "",
    guestUser = false,
    isOpen,
    setIsOpen,
    path,
    onSuccessClose,
  } = props;
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setIsOpen(false);
    navigate(path);
  };
  const { t } = useTranslation();
  const sendHandler = () => {
    if (onSuccessClose) {
      onSuccessClose();
    } else {
      setIsOpen(false);
      window.location.reload();
    }
    setIsOpen(false);
    // window.close();
    // navigate(path);
  };

  return (
    <>
      <Modal
        open={isOpen}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={sucessImage}
              width="108px"
              height="108px"
              alt="email icon"
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
              flexDirection: "column",
            }}
          >
            <Typography
              component={"h6"}
              sx={{
                color: "neutral.900",
                fontSize: 20,
                fontFamily: "Gilroy-SemiBold",
                textAlign: "center",
              }}
            >
              {t("thanks.thank")}
              <Box component={"span"} sx={{ color: "primary.main" }}>
                {" "}
                {t("thanks.pr")}{" "}
              </Box>
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              mt: 4,
            }}
          >
            <Button
              onClick={sendHandler}
              sx={{
                backgroundColor: "primary.main",
                py: 1,
                px: { xs: 4, sm: 8 },
                fontSize: "18px",
                fontFamily: "Gilroy-Medium",
                textTransform: "capitalize",
              }}
              variant="contained"
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default SuccessfullModal;
